import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { object, string } from 'yup';
import { useTranslation } from 'react-i18next';
import { shallow } from '@jwp/ott-common/src/utils/compare';
import type { ForgotPasswordFormData } from '@jwp/ott-common/types/account';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';
import { modalURLFromLocation } from '@jwp/ott-ui-react/src/utils/location';
import useForm from '@jwp/ott-hooks-react/src/useForm';

import ConfirmationForm from '../../../components/ConfirmationForm/ConfirmationForm';
import LoadingOverlay from '../../../components/LoadingOverlay/LoadingOverlay';

type Prop = {
  type: 'confirmation' 
  isChangePassword?: boolean;
};

const ChangePassword: React.FC<Prop> = ({ type }: Prop) => {
  const accountController = getModule(AccountController);

  const { t } = useTranslation('user');
  const navigate = useNavigate();
  const location = useLocation();
  const [resetPasswordSubmitting, setResetPasswordSubmitting] = useState<boolean>(false);

  const { customer: user } = useAccountStore(
    ({ user }) => ({
      customer: user,
    }),
    shallow,
  );

  const emailSubmitHandler = async () => {
    const resetUrl = `${window.location.origin}/?u=edit-password`;
    setResetPasswordSubmitting(true);
    try {
      await accountController.resetPassword(user?.email || emailForm.values.email, resetUrl);
      // const modal = canChangePasswordWithOldPassword ? 'edit-password' : 'send-confirmation';
      //   navigate(modalURLFromLocation(location, 'send-confirmation'));
        navigate(modalURLFromLocation(location, null));
    } catch (error: unknown) {
      if (error instanceof Error) {
        if (error.message.toLowerCase().includes('invalid param email')) {
          console.log('invalid param email error in resetPassword', error.message);
          //   setErrors({ email: t('reset.wrong_email') });
        } else {
          console.log('error in resetPassword', error.message);
          //   setErrors({ form: error.message });
        }
      }
    } finally {
      setResetPasswordSubmitting(false);
    }
    // setSubmitting(false);
  };

  const emailForm = useForm<ForgotPasswordFormData>({
    initialValues: { email: '' },
    validationSchema: object().shape({
      email: string()
        .email(t('login.field_is_not_valid_email'))
        .required(t('login.field_required', { field: t('login.email') })),
    }),
    validateOnBlur: true,
    onSubmit: emailSubmitHandler,
  });

  return (
    <React.Fragment>
      {type === 'confirmation' && (
        <ConfirmationForm
          isShowReset={true}
          loggedIn={!!user}
          email={user?.email || emailForm.values.email}
          onClickResetPassword={emailSubmitHandler}
          isChangePassword={t('account.send_link')}
          title={t('account.change_password')}
          description={t('account.change_password_description')}
        />
      )}

      {resetPasswordSubmitting && <LoadingOverlay transparentBackground inline />}
    </React.Fragment>
  );
};

export default ChangePassword;
